import React, { useEffect, useState } from "react";
import { LANDING } from "@/constants/testIds";

function getEnd() {
  const stored = parseInt(localStorage.getItem("dp_countdown_end") || "0", 10);
  const now = Date.now();
  if (!stored || stored < now) {
    const end = now + 24 * 60 * 60 * 1000;
    localStorage.setItem("dp_countdown_end", String(end));
    return end;
  }
  return stored;
}

// Rotating trust messages — cycle every 4s on mobile / always visible row on desktop
const TRUST_ROTATION = [
  { flag: "🇺🇸", text: "Registered US Company" },
  { flag: "🛡️", text: "100% Secure Checkout · SSL 256-bit" },
  { flag: "🇺🇸🇪🇺", text: "Ships from USA & Europe · 2-5 day delivery" },
  { flag: "⚡", text: "Orders processed within 24h" },
];

export default function AnnouncementBarV2() {
  const [end, setEnd] = useState(getEnd);
  const [remaining, setRemaining] = useState(end - Date.now());
  const [rotIdx, setRotIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      const r = end - Date.now();
      if (r <= 0) {
        const newEnd = Date.now() + 24 * 60 * 60 * 1000;
        localStorage.setItem("dp_countdown_end", String(newEnd));
        setEnd(newEnd);
      } else {
        setRemaining(r);
      }
    }, 1000);
    return () => clearInterval(t);
  }, [end]);

  // Rotate trust messages every 4 seconds (mobile)
  useEffect(() => {
    const t = setInterval(() => {
      setRotIdx((i) => (i + 1) % TRUST_ROTATION.length);
    }, 4000);
    return () => clearInterval(t);
  }, []);

  const fmt = (ms) => {
    const s = Math.max(0, Math.floor(ms / 1000));
    const h = String(Math.floor(s / 3600)).padStart(2, "0");
    const m = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
    const sec = String(s % 60).padStart(2, "0");
    return `${h}:${m}:${sec}`;
  };

  const current = TRUST_ROTATION[rotIdx];

  return (
    <div
      data-testid={LANDING.announcementBar}
      className="bg-[#0e0e10] text-white text-[12px] py-2.5 text-center"
    >
      <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1">
        <span className="inline-flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-[#d8f06b] pulse-dot" />
          Sale ends in{" "}
          <span
            data-testid={LANDING.countdownTimer}
            className="font-mono font-bold text-[#d8f06b]"
          >
            {fmt(remaining)}
          </span>
        </span>
        {/* Rotating trust message — replaces the static 7-star line */}
        <span
          key={rotIdx}
          data-testid="announcement-trust-rotation"
          className="hidden sm:inline-flex items-center gap-1.5 text-white/85"
          style={{ animation: "fadeSlide 0.5s ease-out" }}
        >
          <span className="text-[14px] leading-none">{current.flag}</span>
          <span className="font-medium">{current.text}</span>
        </span>
      </div>
      <style>{`
        @keyframes fadeSlide {
          from { opacity: 0; transform: translateY(-2px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
